var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("A new "+_vm._s(_vm.sampleType)+" is planned")]),(_vm.deadline)?_c('div',[_vm._v("Deadline set to "+_vm._s(_vm.deadline))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }